// global.gsap = require("gsap");
// import gsap from "gsap";
// import testWebp from "./modules/sub/testwebp";

"use scrict";

// viiksi <3 legacy
  global.$ = require("jquery");

// messy globals + device detects
  const MobileDetect = require('mobile-detect');
  global.md = new MobileDetect(window.navigator.userAgent);
  global.MOBILE = md.mobile();
  global.TOUCH = (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
  global.TABLET = navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  global.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

// generic modules
  import winsizes from './modules/winsizes';
  import kasher from './modules/vx.kasher';
  import drags from './modules/vx.drags';

// threejs imports
  import * as THREE from 'three';
  import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils.js";
  global.THREE = THREE;
  global.BufferGeometryUtils = BufferGeometryUtils;

  global.MOBSIZE = window.innerWidth <= 767;

// other
  window.winsizes = new winsizes();

  import page from './pages/_basic';
  import menu from './parts/menu';

// on document ready

$(function(){
  if(!window.page) window.page = new page();
  if(!window.menu) window.menu = new menu();

  $('a[href*="'+siteurl+'"]').click(function(e){
    if(e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) {

  } else {
    e.preventDefault();
    if(!window.preventClick) {
      window.preventClick = true;
      var href = $(this).attr('href');
      $('.wrap').removeClass('in');
      $('body').addClass('blackout');
      
      setTimeout(function(){
        window.location.href = href;
      }, 200);
    }
  }
  });

  const draggables = new drags();
  setTimeout(function(){
    const kashers = new kasher();
  }, 1);
});

$(window).resize(function(){
  window.winsizes.resize();
});
